import axios from '@/utils/request'
//资产概况

export const getAssets = (params)=>{
  return axios.request({
     url: 'v1/assets/assets/index',
     method: 'get',
     params
   })
};

/**
 * 
 * 积分
 */

// 获取积分配置详情
export const getPoint = (params)=>{
 return axios.request({
    url: 'v1/setting/pointRead',
    method: 'get',
    params
  })
};
// 积分配置
export const setPoint = (data)=>{
  return axios.request({
     url: 'v1/setting/point',
     method: 'POST',
     data
   })
 };
 // 积分清理
export const point_is_clear = (data)=>{
  return axios.request({
     url: 'v1/setting/point_is_clear',
     method: 'POST',
     data
   })
 };
// 获取积任务
export const getIntegralList = (params)=>{
  return axios.request({
    url: 'v1/integral/index',
    method: 'get',
    params
  })
};
// 积分 - 积分任务添加
export const getIntegralAdd = (data)=>{
  return axios.request({
    url: 'v1/integral/save',
    method: 'post',
    data
  })
};
// 积分 - 积分任务编辑
export const getIntegralEdit = (data)=>{
  return axios.request({
    url: 'v1/integral/update',
    method: 'post',
    data
  })
};
// 积分 - 积分任务启用禁用
export const getIntegralState = (data)=>{
  return axios.request({
    url: 'v1/integral/state',
    method: 'post',
    data
  })
};
// 积分 - 积分任务删除
export const getIntegralDel = (data)=>{
  return axios.request({
    url: 'v1/integral/del',
    method: 'post',
    data
  })
};
// 积分 - 积分任务详情
export const getIntegralMore = (params)=>{
  return axios.request({
    url: 'v1/integral/read',
    method: 'get',
    params
  })
};
// 积分 - 积分统计 - 积分明细
export const getIntegralPointLog = (params)=>{
  return axios.request({
    url: 'v1/integral/point/pointLog',
    method: 'get',
    params
  })
};
// 积分 - 积分统计 - 积分概况
export const getIntegralGeneralLog = (params)=>{
  return axios.request({
    url: 'v1/integral/point/generalLog',
    method: 'get',
    params
  })
};
//积分 - 积分中心详情
export const getIntegralTemplate = (params)=>{
  return axios.request({
    url: 'v1/integral/center/pointTemplate',
    method: 'get',
    params
  })
};
//积分 - 积分中心设置
export const setIntegralTemplate = (data)=>{
  return axios.request({
    url: 'v1/integral/center/createPointTemplate',
    method: 'post',
    data
  })
};
//积分 - 用户积分明细
export const mermberPointList = (params)=>{
  return axios.request({
    url: 'v1/integral/point/pointList',
    method: 'get',
    params
  })
};

/**
 * 
 * 卡券管理
 */

//卡券列表
export const getCouponList = (params)=>{
  return axios.request({
    url: 'v1/assets/coupon/index',
    method: 'get',
    params
  })
};
//卡券详情
export const getCouponMore = (id)=>{
  return axios.request({
    url: 'v1/assets/coupon/read?id='+id,
    method: 'get'
  })
};
//卡券添加
export const setCouponAdd = (data)=>{
  return axios.request({
    url: 'v1/assets/coupon/save',
    method: 'POST',
    data
  })
};
//卡券编辑
export const setCouponEdit = (data)=>{
  return axios.request({
    url: 'v1/assets/coupon/update',
    method: 'POST',
    data
  })
};
//卡券生效失效
export const setCouponState = (data)=>{
  return axios.request({
    url: 'v1/assets/coupon/state',
    method: 'POST',
    data
  })
};
//卡券-使用明细
export const getCouponUseList = (params)=>{
  return axios.request({
    url: 'v1/assets/coupon/usedList',
    method: 'get',
    params
  })
};
//卡券-发放明细
export const getCouponGrantList = (params)=>{
  return axios.request({
    url: 'v1/assets/coupon/grantList',
    method: 'get',
    params
  })
};


/**
 * 
 * 包邮卡
 */

//包邮卡 - 列表
export const getParcelList = (params)=>{
  return axios.request({
    url: 'v1/assets/parcel/index',
    method: 'get',
    params
  })
};
//包邮卡 - 详情
export const getParcelMore = (id)=>{
  return axios.request({
    url: 'v1/assets/parcel/read?id='+id,
    method: 'get'
  })
};
//包邮卡 - 新增
export const setParcelAdd = (data)=>{
  return axios.request({
    url: 'v1/assets/parcel/save',
    method: 'POST',
    data
  })
};
//包邮卡 - 编辑
export const setParcelEdit = (data)=>{
  return axios.request({
    url: 'v1/assets/parcel/update',
    method: 'POST',
    data
  })
};
//包邮卡 - 状态
export const setParcelState = (data)=>{
  return axios.request({
    url: 'v1/assets/parcel/state',
    method: 'POST',
    data
  })
};
//包邮卡 - 领取列表
export const getParcelUseList = (params)=>{
  return axios.request({
    url: 'v1/assets/parcel/getLog',
    method: 'get',
    params
  })
};
// 获取任务对应的会员
export const getTaskCard = (params)=>{
  return axios.request({
    url: 'v1/integral/getTaskCard',
    method: 'get',
    params
  })
};
export const getTaskType = (params)=>{
  return axios.request({
    url: 'v1/integral/index',
    method: 'get',
    params
  })
};
/**
 * 
 * 提货券
 */
//提货券列表
export const getPickUpCouponList = (params)=>{
  return axios.request({
    url: 'v1/assets/voucher/index',
    method: 'get',
    params
  })
};
//提货券删除
export const delPickUpCoupon = (data)=>{
  return axios.request({
    url: 'v1/assets/voucher/delete',
    method: 'POST',
    data
  })
};
//提货券禁用-启用
export const statePickUpCoupon = (data)=>{
  return axios.request({
    url: 'v1/assets/voucher/state',
    method: 'POST',
    data
  })
};

//提货券添加
export const createPickUpCoupon = (data)=>{
  return axios.request({
    url: 'v1/assets/voucher/save',
    method: 'POST',
    data
  })
};
//提货券详情一
export const pickUpCouponDetailOne = (params)=>{
  return axios.request({
    url: 'v1/assets/voucher/detail',
    method: 'get',
    params
  })
};
//提货券更新
export const updatePickUpCoupon = (data)=>{
  return axios.request({
    url: 'v1/assets/voucher/update',
    method: 'POST',
    data
  })
};
// 提货卷范围列表
export const getVoucherList = (params)=>{
  return axios.request({
    url: 'v1/assets/voucher/range/index',
    method: 'get',
    params
  })
};
// 提货卷批次列表
export const getVoucherBatchList = (params)=>{
  return axios.request({
    url: 'v1/assets/voucher/range/batch',
    method: 'get',
    params
  })
};
// 提货卷添加批次
export const setVoucherBatchList = (data)=>{
  return axios.request({
    url: 'v1/assets/voucher/range/save',
    method: 'POST',
    data
  })
};
// 提货卷删除批次
export const delVoucherBatchList = (data)=>{
  return axios.request({
    url: 'v1/assets/voucher/range/delete',
    method: 'POST',
    data
  })
};
// 提货卷模板详情
export const getVoucherDetailTemplate = (params)=>{
  return axios.request({
    url: 'v1/assets/voucher/detail_template',
    method: 'get',
    params
  })
};
// 提货卷模板更新
export const updateVoucherDetailTemplate = (data)=>{
  return axios.request({
    url: 'v1/assets/voucher/update_template',
    method: 'post',
    data
  })
};

// 提货卷核销列表
export const getVoucherwriteoffList = (params)=>{
  return axios.request({
    url: 'v1/assets/voucher/writeoff/index',
    method: 'get',
    params
  })
};
// 提货卷核销列表-导出
export const getVoucherwriteoffListExport = (params)=>{
  return axios.request({
    url: 'v1/assets/voucher/writeoff/export',
    method: 'get',
    params
  })
};

// 提货卷门店核销统计
export const getStoreVoucherwriteoffList = (params)=>{
  return axios.request({
    url: 'v1/assets/voucher/writeoff/statistics_index',
    method: 'get',
    params
  })
};
// 提货卷门店核销统计 详情
export const getStoreVoucherwriteoffListDetail = (params)=>{
  return axios.request({
    url: 'v1/assets/voucher/writeoff/statistics_detail',
    method: 'get',
    params
  })
};
// 提货卷门店核销统计详情 导出
export const getStoreVoucherwriteoffListDetailExoprt = (params)=>{
  return axios.request({
    url: 'v1/assets/voucher/writeoff/statistics_export',
    method: 'get',
    params
  })
};

// 提货卷配置详情
export const getVoucherShowConfig = (params)=>{
  return axios.request({
    url: 'v1/assets/voucher/show_config',
    method: 'get',
    params
  })
};

// 提货卷配置跟新
export const updateVoucherShowConfig = (data)=>{
  return axios.request({
    url: 'v1/assets/voucher/save_config',
    method: 'post',
    data
  })
};

/**
 * 
 * 优惠券（新）
 */
//优惠券列表
export const getNewCouponList = (params)=>{
  return axios.request({
    url: 'v1/assets/coupon/index',
    method: 'get',
    params
  })
};
//优惠券详情
export const getNewCouponMore = (params)=>{
  return axios.request({
    url: 'v1/assets/coupon/read',
    method: 'get',
    params
  })
};
//优惠券添加
export const newCouponAdd = (data)=>{
  return axios.request({
    url: 'v1/assets/coupon/save',
    method: 'POST',
    data
  })
};
//优惠券编辑
export const newCouponEdit = (data)=>{
  return axios.request({
    url: 'v1/assets/coupon/update',
    method: 'POST',
    data
  })
};
//优惠券生效/失效
export const newCouponState = (data)=>{
  return axios.request({
    url: 'v1/assets/coupon/state',
    method: 'POST',
    data
  })
};
//优惠券删除
export const newCouponDel = (data)=>{
  return axios.request({
    url: 'v1/assets/coupon/delete',
    method: 'POST',
    data
  })
};
//优惠券 - 关联列表
export const getWithActivity = (params)=>{
  return axios.request({
    url: 'v1/assets/coupon/withActivity',
    method: 'get',
    params
  })
};



//优惠券明细
export const getCouponLog = (params)=>{
  return axios.request({
    url: 'v1/memberCoupon/log',
    method: 'get',
    params
  })
};
//优惠券明细生成报表
export const couponDetailReport = (params)=>{
  return axios.request({
    url: 'v1/export',
    method: 'get',
    params
  })
};
//优惠券明细生成报表导出
export const couponDetailReportExport = (params)=>{
  return axios.request({
    url: 'v1/memberCoupon/export',
    method: 'get',
    params
  })
};
//优惠券核销
export const couponwriteOff = (data)=>{
  return axios.request({
    url: 'v1/memberCoupon/writeOff',
    method: 'post',
    data
  })
};

//卡券统计 - 列表
export const couponStatistics = (params)=>{
  return axios.request({
    url: 'v1/assets/coupon/statisticsList',
    method: 'get',
    params
  })
};
//卡券 - 优惠券统计-每日数量统计
export const couponDaysStatistics = (params)=>{
  return axios.request({
    url: 'v1/assets/coupon/daysStatistics',
    method: 'get',
    params
  })
};
//卡券 - 优惠券统计- 渠道统计
export const couponChannelStatistics = (params)=>{
  return axios.request({
    url: 'v1/assets/coupon/channelStatistics',
    method: 'get',
    params
  })
};
//卡券 - 优惠券统计- 门店统计
export const couponStoreStatistics = (params)=>{
  return axios.request({
    url: 'v1/assets/coupon/storeStatistics',
    method: 'get',
    params
  })
};
//资产-概括
export const couponAssetsIndex = (params)=>{
  return axios.request({
    url: 'v1/assets/assets/index',
    method: 'get',
    params
  })
};

//卡券 - 权益卡列表

export const profit = (params)=>{
  return axios.request({
    url: 'v2/profit',
    method: 'get',
    params
  })
};

//卡券 - 权益卡新增
export const profitAdd = (data)=>{
  return axios.request({
    url: 'v2/profit',
    method: 'post',
    data
  })
};

//卡券 - 权益卡产品库sku列表
export const productSkuList = (params)=>{
  return axios.request({
    url: 'v2/profit/productSkuList',
    method: 'get',
    params
  })
};
//卡券 - 权益卡礼品库sku列表
export const giftSkuList = (params)=>{
  return axios.request({
    url: 'v2/profit/giftSkuList',
    method: 'get',
    params
  })
};

//卡券 - 权益卡编辑
export const profitEdit = (data)=>{
  return axios.request({
    url: 'v2/profit/'+data.id,
    method: 'patch',
    data
  })
};

//卡券 - 权益卡详情
export const profitDetail = (params)=>{
  return axios.request({
    url: 'v2/profit/detail/'+params.id,
    method: 'get',
    // params
  })
};

//卡券 - 权益卡删除
export const profitDelete = (params)=>{
  return axios.request({
    url: 'v2/profit/'+params.id,
    method: 'delete',
    // params
  })
};

//卡券 - 权益卡领取明细
export const receiveList = (params)=>{
  return axios.request({
    url: 'v2/profit/receiveList',
    method: 'get',
    params
  })
};

//卡券 - 权益卡-消费者核销明细/门店核销权益卡礼品明细
export const writeList = (params)=>{
  return axios.request({
    url: 'v2/profit/writeList',
    method: 'get',
    params
  })
};

//卡券 - 权益卡 -门店核销统计数量
export const writeNumber = (params)=>{
  return axios.request({
    url: 'v2/profit/writeNumber',
    method: 'get',
    params
  })
};

//卡券 - 权益卡-门店核销统计列表
export const writeStatistics = (params)=>{
  return axios.request({
    url: 'v2/profit/writeStatistics',
    method: 'get',
    params
  })
};

